// extracted by mini-css-extract-plugin
export var chevronIcon = "_5a-2";
export var teamName = "_5a-1";
export var teamSwitcherButton = "_5a-0";